import { styled, Box, BoxProps, Typography, css } from '@mui/material'

export const ProductOptionsListContainer = styled(Box)<BoxProps>(
  () => css`
    width: 100%;
    padding: 4px 0;
    display: flex;
    flex-direction: column;
  `
)

export const ProductOptionsListRow = styled(Box)<BoxProps>(
  () => css`
    width: 100%;
  `
)

export const Label = styled(Typography)(
  ({ theme }) => css`
    font-weight: 500;
    font-size: 10px;
    color: ${theme.palette.grey[600]};
  `
)
